
document.addEventListener("DOMContentLoaded", function () {

    console.log("a11y start");


$("form.multi-selectors button.faux-select.disclosure__toggle").each(function () {
    $(this).attr("role", "combobox").attr("aria-label", "Country Currency, " + $(this).find(".disclosure-list__label").text().trim());});
$('main header').attr('role','none');
$('.product-block.product-block--tab .collapsibles-wrapper .collapsible-content__inner div h4.text-left,three-image-promo-atxrxk0j2atfjogvmeaigenblocke031460fnjvtn .ai-three-promo-header-atxrxk0j2atfjogvmeaigenblocke031460fnjvtn h1').attr({'role':'heading','aria-level':'2'});
$('.product-block.product-block--tab .collapsibles-wrapper .collapsible-content__inner div h5').attr({'role':'heading','aria-level':'3'});
$('.jdgm-carousel__left-arrow').attr({'role':'button','aria-label':'previous'});
$('.jdgm-carousel__right-arrow').attr({'role':'button','aria-label':'next'});
var pageClass = window.location.pathname.replace(/^\/|\/$/g, "").split("/").pop().replace(/[^a-zA-Z0-9]+/g, "-").toLowerCase();
if (pageClass) {
    $("body").addClass(pageClass);
} else {
    $("body").addClass("home");
}

// 
const initVariantRadios = () => {
    document.querySelectorAll(".variant-input-wrap").forEach(fieldset => {
        if (fieldset.dataset.a11yInit) return;
        fieldset.dataset.a11yInit = "true";
        const update = () => {
            fieldset.querySelectorAll(".variant__button-label").forEach(label => {
                const input = document.getElementById(label.htmlFor);
                if (!input) return;
                label.setAttribute("role", "radio");
                label.setAttribute("aria-checked", input.checked ? "true" : "false");
                label.setAttribute("tabindex", input.checked ? "0" : "-1");});};
        update();
        fieldset.addEventListener("click", () => {setTimeout(update, 0);});
        fieldset.addEventListener("keydown", e => {
            const labels = [
                ...fieldset.querySelectorAll(".variant__button-label")];
            const currentLabel = document.activeElement;
            if (!labels.includes(currentLabel)) return;
            let index = labels.indexOf(currentLabel);
            if (
                e.key === "ArrowRight" ||
                e.key === "ArrowDown"
            ) {
                e.preventDefault();
                index = (index + 1) % labels.length;
                labels[index].focus();}
            else if (
                e.key === "ArrowLeft" ||
                e.key === "ArrowUp"
            ) {
                e.preventDefault();
                index = (index - 1 + labels.length) % labels.length;
                labels[index].focus();}
            else if (
                e.key === "Enter" ||
                e.key === " "
            ) {
                e.preventDefault();
                const input = document.getElementById(currentLabel.htmlFor);
                if (input) {
                    input.click();
                    setTimeout(update, 0);}
            }});});
};
initVariantRadios();
new MutationObserver(initVariantRadios).observe(document.body, {childList: true,subtree: true});
// 
const globalA11yObserver = new MutationObserver(function () {
   $('ul.swatch-view li.swatch-view-item span[role="img"][aria-label]').each(function () {
        var label = $(this).attr("aria-label");
        if (label) {$(this).closest("li.swatch-view-item").attr("title", label);}
    });
    $('#yotpo-drawer-layout .yotpo-account-connect .yotpo-drawer-logged-out-headline-text,.atlas-drawer.kl-hub-drawer .atlas-drawer__header h4.kl-hub-text,.jdgm-revs-tab__content-header form.jdgm-form .jdgm-form__title').attr({'role':'heading','aria-level':'2'});
    $('#yotpo-drawer-layout .yotpo-close-icon').attr('aria-label','close');
    $('#yotpo-drawer-layout .yotpo-drawer-sign-up-item,#yotpo-drawer-layout .yotpo-drawer-sign-in-link').attr('role','link');
    $('.jdgm-legacy-widget-content .jdgm-revs-tab__main .jdgm-rev-widg__sort-wrapper label span.jdgm-sort-dropdown-label').removeAttr('style');
    $('.jdgm-revs-tab__content-header form.jdgm-form input[placeholder="Display name"]').attr('autocomplete','name');
    $('.jdgm-revs-tab__content-header form.jdgm-form input[type="email"]').attr('autocomplete','email');
    $('.jdgm-revs-tab__content-header .jdgm-notification').attr('role','alert');
    let reviewForm = $('.jdgm-revs-tab__content-header form.jdgm-form');
    if (reviewForm.length) {
    if (!reviewForm.find('.required_message').length) {reviewForm.find('.jdgm-form__title').after('<div class="required_message">Fields marked with * are required.</div>');}
    reviewForm.find('label[for]').each(function () {
        let label = $(this);
        let fieldId = label.attr('for');
        let field = $('#' + fieldId);
        if (
            field.length &&
            field.is('[required]') &&
            !label.find('.required-star').length
        ) {
            label.append('<span class="required-star" aria-hidden="true"> *</span>');}});
    let ratingField = reviewForm.find('.jdgm-form__rating[aria-required="true"]');
    if (ratingField.length) {
        let ratingLabel = ratingField.closest('.jdgm-form__fieldset').find('label').first();
        if (!ratingLabel.find('.required-star').length) {ratingLabel.append('<span class="required-star" aria-hidden="true"> *</span>');}
    }
    let ratingError = reviewForm.find('#score-error');
    if (
        ratingError.length &&
        ratingError.text().trim() !== 'Please select a rating.'
    ) { ratingError.text('Please select a rating.');}
    reviewForm.find('textarea[required]').each(function () {
        let fieldId = $(this).attr('id');
        let error = reviewForm.find('#' + fieldId + '-error');
        let message = 'Please enter your review content.';
        if (
            error.length &&
            error.text().trim() !== message
        ) {error.text(message);}
    });
    reviewForm.find('input[required]').each(function () {
        let fieldId = $(this).attr('id');
        let fieldName = $(this).attr('aria-label');
        let error = reviewForm.find('#' + fieldId + '-error');
        if (fieldId && fieldName && error.length) {
            let message ='Please enter your ' + fieldName.toLowerCase() + '.';
            if (error.text().trim() !== message) {error.text(message);
            }}});
     let reviewTextarea = reviewForm.find('textarea[name="review_body"]');
    let reviewCountdown = reviewTextarea.siblings('.jdgm-countdown');
    if (reviewTextarea.length && reviewCountdown.length) {
        reviewCountdown.attr('aria-hidden', 'true');
        let countId = reviewTextarea.attr('id') + '-character-count';
        if (!reviewForm.find('#' + countId).length) {
            reviewCountdown.after('<span id="' + countId + '" class="sr-only"></span>');
            reviewTextarea.attr('aria-describedby', countId);
        }
        let updateCharacterCount = function () {
            let remaining =5000 - reviewTextarea.val().length;
            let countText =remaining + ' characters remaining.';
            if ($('#' + countId).text() !== countText
            ) {$('#' + countId).text(countText);}
        };
        updateCharacterCount();
        reviewTextarea.off('input.characterCount').on('input.characterCount', updateCharacterCount);}
}
// 
let reviewTabs = $('.jdgm-revs-tab__main .jdgm-revs-tab__content .jdgm-subtab');
if (reviewTabs.length) {
    reviewTabs.attr('role', 'tablist');
    let tabs = reviewTabs.find('.jdgm-subtab__name');
    tabs.each(function () {
        let tab = $(this);
        tab.attr('role', 'tab');
        if (tab.hasClass('jdgm--active')) {tab.attr({'aria-selected': 'true','tabindex': '0'});
        } else {tab.attr({'aria-selected': 'false','tabindex': '-1'});}});
    tabs.off('keydown.reviewTabs').on('keydown.reviewTabs', function (e) {
        let currentTab = $(this);
        let currentIndex = tabs.index(currentTab);
        let nextIndex;
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            nextIndex = currentIndex + 1;
            if (nextIndex >= tabs.length) {nextIndex = 0;}
            tabs.eq(nextIndex).focus();}
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            nextIndex = currentIndex - 1;
            if (nextIndex < 0) {nextIndex = tabs.length - 1;}
            tabs.eq(nextIndex).focus();}
        });
}
// 
let reviewList=$('.jdgm-revs-tab__main .jdgm-revs-tab__content .jdgm-revs-tab__reviews');
if(reviewList.length){
reviewList.find('.jdgm-rev__share-btn').each(function(){
let shareBtn=$(this);
let review=shareBtn.closest('.jdgm-rev');
let reviewerName=review.find('.jdgm-rev__author').text().trim();
let socialName=shareBtn.attr('data-social-media');
if(reviewerName&&socialName){
let shareLabel='Share '+reviewerName+"'s review on "+socialName;
if(shareBtn.attr('aria-label')!==shareLabel){shareBtn.attr('aria-label',shareLabel);}
shareBtn.attr('role','link');
}});
reviewList.find('.jdgm-rev__social-inner').each(function(){
let socialList=$(this);
if(!socialList.children('ul.jdgm-social-list').length){
let shareButtons=socialList.children('.jdgm-rev__share-btn');
if(shareButtons.length){
shareButtons.wrapAll('<ul class="jdgm-social-list"></ul>');
shareButtons.each(function(){let shareButton=$(this);
if(!shareButton.parent().is('li')){shareButton.wrap('<li></li>');}});}
}});
}
// 
let pagination=$('.jdgm-revs-tab__main .jdgm-revs-tab__content .jdgm-paginate');
if(pagination.length){
pagination.attr({'role':'navigation','aria-label':'Pagination'});
pagination.each(function(){
let paginationItem=$(this);
if(!paginationItem.children('ul.jdgm-pagination-list').length){
let pageButtons=paginationItem.children('.jdgm-paginate__page');
if(pageButtons.length){
pageButtons.wrapAll('<ul class="jdgm-pagination-list"></ul>');
pageButtons.each(function(){
let pageButton=$(this);
if(!pageButton.parent().is('li')){pageButton.wrap('<li></li>');}
});}}
});
pagination.find('.jdgm-paginate__page').each(function(){
let pageButton=$(this);
let pageNumber=pageButton.attr('data-page');
if(pageButton.hasClass('jdgm-curt')){
pageButton.attr('aria-current','page');
pageButton.removeAttr('aria-label');
}else if(pageButton.hasClass('jdgm-paginate__first-page')){
pageButton.attr('aria-label','First page');
}else if(pageButton.hasClass('jdgm-paginate__prev-page')){
pageButton.attr('aria-label','Previous page');
}else if(pageButton.hasClass('jdgm-paginate__next-page')){
pageButton.attr('aria-label','Next page');
}else if(pageButton.hasClass('jdgm-paginate__last-page')){
pageButton.attr('aria-label','Last page');
}else{pageButton.attr('aria-label','Page '+pageNumber);
}});
}
// 
let $searchInput = $('predictive-search .search__input#Search');
let $predictiveSearch = $('predictive-search #predictive-search');
if ($predictiveSearch.css("display") === "block") {$searchInput.attr("aria-expanded", "true");
} else {$searchInput.attr("aria-expanded", "false");} 
// form
$("form.jdgm-ask-question-form__body").each(function () {
    let $form = $(this);
    if (!$form.find(".required_message").length) {$form.prepend('<div class="required_message">Fields marked with * are required.</div>');}
    $form.find("input[required], textarea[required], select[required]"
    ).each(function () {
        let $field = $(this);
        let fieldId = $field.attr("id");
        if (!fieldId) return;
        let $label = $form.find('label[for="' + fieldId + '"]');
        if (!$label.length) return;
        let labelText = $label.text().replace(/\(Required\)/gi, "").replace(/\*/g, "").trim();
        if (!$label.find(".required-star").length) {$label.append(' <span class="required-star" aria-hidden="true">*</span>');}
        let errorId = $field.attr("aria-errormessage");
        if (errorId) {
            let $errorMessage = $("#" + errorId);
            if ($errorMessage.length) {
                if ($errorMessage.text().trim().toLowerCase() === "this field is required"
                ) {$errorMessage.text(labelText + " is required.");}
                $field.attr("aria-describedby",errorId);}}});
        let $firstInvalidField = $form.find('input[aria-invalid="true"], textarea[aria-invalid="true"], select[aria-invalid="true"]').first();
    if ($firstInvalidField.length) {setTimeout(function () {$firstInvalidField.focus();}, 100);}
});
// 
$('.slideshow-wrapper .announcement-slider,.slideshow-wrapper .hero').removeAttr('tabindex');
//
if ($(".jdgm-form__rating").length) {

    $(".jdgm-form__rating").each(function () {

        const $stars = $(this).find(".jdgm-star");

        $stars.attr("tabindex", "-1");

        const selectedIndex = $stars.index(
            $stars.filter('[aria-checked="true"]')
        );

        $stars.eq(selectedIndex >= 0 ? selectedIndex : 0)
            .attr("tabindex", "0");

    });

    $(document).off("keydown.jdgmRating", ".jdgm-form__rating .jdgm-star")
        .on("keydown.jdgmRating", ".jdgm-form__rating .jdgm-star", function (event) {
            const $rating = $(this).closest(".jdgm-form__rating");
            const $stars = $rating.find(".jdgm-star");
            let currentIndex = $stars.index(this);
            let newIndex = currentIndex;
            if (
                event.key === "ArrowRight" ||
                event.key === "ArrowDown"
            ) {
                event.preventDefault();
                newIndex = currentIndex === $stars.length - 1
                    ? 0
                    : currentIndex + 1;
            }
            if (
                event.key === "ArrowLeft" ||
                event.key === "ArrowUp"
            ) {
                event.preventDefault();
                newIndex = currentIndex === 0
                    ? $stars.length - 1
                    : currentIndex - 1;
            }

            if (event.key === "Home") {
                event.preventDefault();
                newIndex = 0;
            }

            if (event.key === "End") {
                event.preventDefault();
                newIndex = $stars.length - 1;
            }
            if (newIndex !== currentIndex) {
                const $newStar = $stars.eq(newIndex);
                $stars
                    .removeClass("jdgm--on")
                    .addClass("jdgm--off")
                    .attr("aria-checked", "false")
                    .attr("tabindex", "-1");
                $stars.slice(0, newIndex + 1)
                    .removeClass("jdgm--off")
                    .addClass("jdgm--on");
                $newStar
                    .attr("aria-checked", "true")
                    .attr("tabindex", "0");
                $rating.find("input[name='score']")
                    .val(newIndex + 1);
                $newStar.focus();
            }
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                $(this).trigger("click");
            }
        });
    $(document).off("click.jdgmRating", ".jdgm-form__rating .jdgm-star")
        .on("click.jdgmRating", ".jdgm-form__rating .jdgm-star", function () {
            const $stars = $(this)
                .closest(".jdgm-form__rating")
                .find(".jdgm-star");
            const index = $stars.index(this);
            $stars.attr("tabindex", "-1");
            $stars
                .slice(0, index + 1)
                .removeClass("jdgm--off")
                .addClass("jdgm--on");
            $stars
                .slice(index + 1)
                .removeClass("jdgm--on")
                .addClass("jdgm--off");
            $stars.attr("aria-checked", "false");
            $(this)
                .attr("aria-checked", "true")
                .attr("tabindex", "0");
            $(this)
                .closest(".jdgm-form__rating")
                .find("input[name='score']")
                .val(index + 1);
        });
}

$(".product__main-photos [data-product-photos].product-slideshow").attr("tabindex", "-1");
$('.product-single__meta form.product-single__form .errors.text-center').attr('role','alert');
$(".cbb-also-bought-container .cbb-also-bought-slider-list li").each(function () {
    const productTitle = $(this).find("h3.cbb-also-bought-product-name").text().trim();
    $(this).find("button.cbb-also-bought-add-to-cart-button").attr("aria-label", "Add " + productTitle + " to cart");
});
$(".ks-chart-modal-link.sizing-chart-modal-link.with-icon").attr({"role": "button","tabindex": "0"});
$('.kiwi-sizing-modal .ks-modal-close').attr('tabindex','0');
$(".jm-rating-filter__tag").each(function () {
    const $ratingTag = $(this);
    const $ratingInput = $ratingTag.find("input[name='rating-filter']");
    if (
        $ratingTag.hasClass("jm-rating-filter__tag--selected")
    ) {
        $ratingInput.prop("checked", true).attr("checked", "checked");
    } else {
        $ratingInput.prop("checked", false).removeAttr("checked");
    }
});
$('.jm-review-widget__header-and-body .jm-loading-overlay .jdgm-empty-state p,.jdgm-review-widget-modal .jdgm-write-review-modal__form--thank-you').attr('role','alert');
$('.jdgm-modal-block__body .jdgm-form-tabs__page .jdgm-ask-question-form__header,.jdgm-write-review-modal__content .jdgm-write-review-modal__page-header .jdgm-write-review-modal__title,.jdgm-write-review-modal__content .jdgm-write-review-modal__page-header .jdgm-write-review-modal__product-title,.jdgm-review-widget-modal .jdgm-write-review-modal__form--thank-you .jdgm-write-review-modal__title').attr({'role':'heading','aria-level':'2'});
const $modalContent = $(".jdgm-modal.jdgm-widget-revamp .jdgm-modal__content");
const labelText = $(".jm-review-widget__header-and-body .jm-action-buttons button.jm-button--secondary").first().text().trim();
if ($modalContent.length && labelText) {$modalContent.attr("aria-label", labelText);}
// 
$(".cbb-frequently-bought-form").each(function () {
    const $form = $(this);
    const $totalPrice = $form.find(".cbb-frequently-bought-total-price-text");
    const $wasPrice = $form.find(".cbb-frequently-bought-total-price-was-price");
    const $salePrice = $form.find(".cbb-frequently-bought-total-price-sale-price");
    if (!$wasPrice.length || !$salePrice.length) return;
    if ($form.find(".cbb-price-announcement").length) return;
    const wasPriceText = $wasPrice.text().trim();
    const salePriceText = $salePrice.text().trim();
    $totalPrice.attr("aria-hidden", "true");
    $wasPrice.attr("aria-hidden", "true");
    $salePrice.attr("aria-hidden", "true");
    $('<span class="cbb-price-announcement sr-only">' + 'Regular price ' + wasPriceText + '. Discounted price ' + salePriceText + '</span>').insertAfter($salePrice);
});
$('jdgm-review-snippet-widget-v2 .jm-carousel,.yotpo-widget-referral-widget .yotpo-tile-box .yotpo-header-text').removeAttr('tabindex');
$('.grid__item.medium-up--three-fifths .product-single__meta .product-block .rte p strong,.kiwi-sizing-modal .ks-modal-header .modal-title-header').attr({'role':'heading','aria-level':'2'});
$(".kiwi-sizing-modal table.ks-table").each(function () {
    let $table = $(this);
    $table.find("tr:first .ks-table-header-cell").each(function () {
        let $td = $(this);
        if ($td.is("td")) {
            $("<th>", {
                class: $td.attr("class"),
                scope: "col",
                text: $td.text().trim()
            }).replaceAll($td);
        } else {
            $td.attr("scope", "col");
        }
    });
    $table.find("tr:not(:first)").each(function () {
        let $firstCell = $(this).children().first();
        if ($firstCell.is("td")) {
            $("<th>", {
                class: $firstCell.attr("class"),
                scope: "row",
                text: $firstCell.text().trim()
            }).replaceAll($firstCell);
        } else if ($firstCell.is("th")) {
            $firstCell.attr("scope", "row");
        }
    });});
$(".cbb-frequently-bought-container ul.cbb-frequently-bought-selector-list li h3").each(function () {
    const $h3 = $(this);
    const $div = $("<div>");
    $.each(this.attributes, function () {$div.attr(this.name, this.value);});
    $div.html($h3.html());
    $h3.replaceWith($div);
});
$(".yotpo-widget-referral-widget form.yotpo-referral-widget-form .yotpo-email-container input").each(function (index) {
    const $input = $(this);
    const $container = $input.closest(".yotpo-email-container");
    const $example = $container.find(".yotpo-input-example");
    $input.attr("autocomplete", "email");
    const exampleId = "yotpo-email-example-" + index;
    $example.attr("id", exampleId);
    $input.attr("aria-describedby", exampleId);
});
$('.yotpo-widget-referral-widget form.yotpo-referral-widget-form .yotpo-email-container .yotpo-referral-widget-error-message').attr('role','alert');
$('.jm-review-widget__header-and-body .jdgm-tabs .jm-sort-filter label').removeAttr('class');
$('.refer-a-friend .yotpo-widget-referral-widget .yotpo-email-view,.refer-a-friend .yotpo-widget-referral-widget .yotpo-email-view .yotpo-header-text').removeAttr('role aria-level');
$('.refer-a-friend .yotpo-widget-referral-widget .yotpo-email-view .yotpo-title-text').attr({'role':'heading','aria-level':'2'});
$('.refer-a-friend .yotpo-widget-referral-widget .yotpo-email-view form input').attr('aria-required','true');
$('body.press a[href="http://www.seattletimes.com/nwshowcase/shop-northwest/new-seattle-clothing-line-buki-lets-its-fabrics-be-the-star/"]').filter(function () {return $(this).children().length === 0 && $.trim($(this).text()) === '';}).remove();
$('.store-locator h2#store-locator-title').attr({'role':'heading','aria-level':'1'});
$('.show-addresses .sl-legacy-address-list-shell ul li').removeAttr('tabindex');
$('.show-addresses .sl-legacy-address-list-shell ul li').each(function () {
    const storeName = $(this).find('.sl-store-name').text().trim();
    $(this).find('a.sl-link').attr('aria-label','Website for ' + storeName);
});
$('.show-addresses .sl-legacy-address-list-shell ul').removeAttr('aria-hidden').attr('role','presentation');
$('.show-addresses #store_map .gm-style div[role="button"]').attr('aria-label','location mark');
$('.jdgm-tablist__list[role="tablist"] > button.jdgm-tab').off('keydown.reviewTabs').on('keydown.reviewTabs', function (e) {
        let currentIndex = $('.jdgm-tablist__list[role="tablist"] > button.jdgm-tab').index(this);
        let nextIndex;
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            nextIndex = currentIndex + 1;
            if (nextIndex >= $('.jdgm-tablist__list[role="tablist"] > button.jdgm-tab').length) {nextIndex = 0;}
            $('.jdgm-tablist__list[role="tablist"] > button.jdgm-tab').eq(nextIndex).focus();}
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            nextIndex = currentIndex - 1;
            if (nextIndex < 0) {nextIndex = $('.jdgm-tablist__list[role="tablist"] > button.jdgm-tab').length - 1;}
            $('.jdgm-tablist__list[role="tablist"] > button.jdgm-tab').eq(nextIndex).focus();}
    });
$('.kiwi-sizing-modal .ks-table-content-wrapper table.ks-table:not(:has(caption))').prepend('<caption class="sr-only">Size Charts Inches</caption>');
$('form.yotpo-referral-widget-form .yotpo-email-container input.yotpo-input').removeAttr('aria-describedby');
$('.yotpo-widget-referral-widget .yotpo-email-view form.yotpo-referral-widget-form label.yotpo-input-label').each(function () {
    if (!$(this).find('.required-asterisk').length) {$(this).append('<span class="required-asterisk"> (required)</span>');}
});
$('.product-main-slide.is-selected .image-wrap.loaded').each(function () {
    if (!$(this).find('button.product__photo-zoom[aria-label]').length) {$(this).find('button.product__photo-zoom').attr('aria-label',$(this).find('img').attr('alt'));}
});
$('.cbb-also-bought-container .cbb-also-bought-slider ul li.cbb-also-bought-product select.cbb-recommendations-variant-select').each(function (index) {
    if (!$(this).attr('id')) {$(this).attr('id', 'cbb-variant-selector-' + index);}
    $(this).removeAttr('aria-label');
    if (!$(this).prev('label').length) {$(this).before('<label for="' + $(this).attr('id') + '">Select variant</label>');}
});
$('.home .promo-grid .flex-grid__item .promo-grid__text h2.h2').attr({'role':'heading','aria-level':'3'});
$('.jdgm-all-reviews-widget-v2025 .jdgm-revs-tab__main .jdgm-revs-tab__header h3.jdgm-revs-tab__title,.how-its-made .grid--product-images-right .product-block--header h1.h2.product-single__title,.our-fabrics fabric-grid-awwdstehtqvrxuuzimaigenblock10c89fe6nqhvq h3.ai-fabric-card__name-awwdstehtqvrxuuzimaigenblock10c89fe6nqhvq').attr({'role':'heading','aria-level':'2'});
$("form.filter-form ul").each(function () {
    let $ul = $(this);
    let $group = $ul.closest(".collection-sidebar__group");
    let label = $.trim($group.find("> button.tag-list__header").clone().children().remove().end().text());
    let $items = $ul.children("li");
    $ul.attr({"role": "group","aria-label": label});
    $items.attr("role", "presentation");
    $items.find("input[type='checkbox']").each(function (i) {
        let $input = $(this);
        let name = $input.closest("label").find(".tag__text").text().trim();
        $input.attr({"aria-label": name + ", " + (i + 1) + " of " + $items.length,"aria-posinset": i + 1,"aria-setsize": $items.length});
    });});
// 
$(".product-slideshow.flickity-enabled.is-draggable").eq(1).removeAttr("tabindex");
$("form.yotpo-referral-widget-form .yotpo-email-container input.yotpo-input").attr("placeholder", "Your email address (required)");
// 
});
globalA11yObserver.observe(document.body, {childList: true,subtree: true});
new MutationObserver(() => {
    document.querySelectorAll(
        'form.contact-form .note.note--success:not([data-focus-init])'
    ).forEach(message => {
        message.dataset.focusInit = 'true';
        message.setAttribute('role', 'alert');
        message.setAttribute('tabindex', '-1');
        setTimeout(() => {
            message.focus();
        }, 100);
    });
}).observe(document.body, {
    childList: true,
    subtree: true
});
setTimeout(function () { 
    document.querySelectorAll(".jdgm-widget .jdgm-prev-badge__stars").forEach(function (star) { 
        const rating =star.getAttribute("data-score") || star.closest(".jdgm-prev-badge")?.getAttribute("data-average-rating");
        if (rating) {star.setAttribute("aria-label",rating + " out of 5 stars");
            star.setAttribute("title", rating + " out of 5 stars");
        }
        star.removeAttribute("tabindex");
    });


}, 2800);
setTimeout(()=>{
    $('.template-collection .shopify-section.index-section h2,.about-buki .hero .hero__text-shadow h2.hero__title,.how-its-made .theme-block h2.h2,.our-fabrics .hero .hero__text-shadow h2.hero__title').attr({'role':'heading','aria-level':'1'});
    $('.contact-us main .section-header h2.section-header__title.h2').attr('aria-hidden', 'true').after('<div role="heading" aria-level="1" class="sr-only">Contact Us</div>');
    $('.mobile-nav__sublist.collapsible-content[aria-labelledby]').removeAttr('aria-labelledby');
    $('.home .promo-grid__container a.promo-grid__slide-link,.hero .flickity-slider a.hero__slide-link[href="/collections/mens-travel"]').remove();
    $('.home .shopify-app-block .jdgm-carousel .jdgm-carousel-item .jdgm-carousel-item__review-rating,product-recommendations .product-recommendations-placeholder .product-single__related').removeAttr('tabindex');
    $('.brandambassadors main .collabs-page__header h1,.press main .rte h1').attr({'role':'heading','aria-level':'2'});
    $('.shipping .table-wrapper table').each(function () {
    const $table = $(this);
    if ($table.find('caption').length) return;
    const $heading = $table.closest('.rte').find('h5').filter(function () {return $(this).nextAll().find($table).length || $(this).parent().next().find($table).length;}).last();
    const headingText = $heading.text().trim();
    if (headingText === 'Contiguous U.S.') {$table.prepend('<caption class="sr-only">Shipping costs and delivery methods for the contiguous United States</caption>');
    } else if (headingText === 'Alaska & Hawaii') {$table.prepend('<caption class="sr-only">Shipping costs and delivery methods for Alaska and Hawaii</caption>');
    } else if (headingText === 'International') {$table.prepend('<caption class="sr-only">International shipping costs and estimated delivery times</caption>');}
    });
    $('.about-buki .video-wrapper iframe,.how-its-made .video-wrapper iframe').attr('title',"Buki's Commitment to Sustainable Clothing");
    $('.about-buki br').attr('aria-hidden','true');
    $('.cart .flex-grid__item.type-banner a.type-banner__link').each(function () {
    const $link = $(this);
    const $content = $link.find('.promo-grid__container');
    const $heading = $link.find('.type-banner__content h2');

    $link.empty().append($heading);
    $link.after($content);
});

    
},1500);
$(document).on("keydown",".kiwi-sizing-modal .ks-unit-toggle-label", function (e) {if (e.key === "Enter" || e.key === " ") {e.preventDefault();
    $(this).trigger("click");}
});
// predictive search component
$('predictive-search button.btn--close-search').attr('aria-label','close');
$("header predictive-search button.btn--close-search").on("click", function () {$("header predictive-search").css("display", "none");
    $(".header-item--navigation a.site-nav__link.js-search-header").focus();});
$(".header-item--navigation a.site-nav__link.js-search-header").on("click", function () {$("header predictive-search").css("display", "flex");});

$('predictive-search').each(function () {
    let $predictiveSearch = $(this);

    if (!$predictiveSearch.find('.predictive-search-announcement').length) {
        $predictiveSearch.find('#predictive-search').after('<div class="predictive-search-announcement visually-hidden" role="status" aria-live="polite" aria-atomic="true"></div>');
    }

    let predictiveSearchObserver = new MutationObserver(function () {
        let $announcement = $predictiveSearch.find('.predictive-search-announcement');
        let $results = $predictiveSearch.find('#predictive-search');

        let suggestions = $results.find('.results--queries').first().find('li').length;
        let products = $results.find('.results--products').first().find('li').length;
        let pages = $results.find('.results__group-1 .results--pages').first().find('li').length;
        let collections = $results.find('.results__group-1 .results--collections').first().find('li').length;

        if (suggestions || products || pages || collections) {
            let message = 'Search results available. ';

            if (suggestions) message += suggestions + ' suggestions. ';
            if (products) message += products + ' products. ';
            if (pages) message += pages + ' pages. ';
            if (collections) message += collections + ' collections.';

            $announcement.text(message);
        }
    });

    let resultsElement = $predictiveSearch.find('#predictive-search')[0];

    if (resultsElement) {
        predictiveSearchObserver.observe(resultsElement, {
            childList: true,
            subtree: true
        });
    }
});
$("predictive-search").each(function () {
    let $search = $(this);
    if (!$search.data("focus-trap")) {
        $search.data("focus-trap", true);
        $search.on("keydown.searchA11y", function (e) {
            if ($search.hasClass("is-active") && e.key === "Tab") {
                let $focusable = $search.find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(":visible");
                if (!$focusable.length) return;
                let first = $focusable[0];
                let last = $focusable[$focusable.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();}
                if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();}}});}
});

// predictive search component end 
// main predictiive search

// 

// 
if ($(".collection-filter__item--sort").length) {
    if (!$("#sort-notification").length) {
        $('<span id="sort-notification"></span>').attr({"role": "alert",}).css({position: "absolute",width: "1px",height: "1px",overflow: "hidden",clip: "rect(0 0 0 0)"}).appendTo(".collection-filter__item--sort");}
    $(document).off("change.sortA11y", "#SortBy").on("change.sortA11y", "#SortBy", function () {sessionStorage.setItem("sortA11y",$(this).find("option:selected").text().trim());});
    var sortText = sessionStorage.getItem("sortA11y");
    if (sortText) {
        sessionStorage.removeItem("sortA11y");
        setTimeout(function () {
            var $status = $("#sort-notification");
            if ($status.length) {
                $status.text("");
                setTimeout(function () {
                    $status.text("Products sorted by " + sortText);}, 100);}
        }, 800);}
}

// 
    const triggerSelector =".yotpo-widget-loyalty-floater-widget .yotpo-banner-layout.yotpo-banner-low";
    const drawerSelector = "#yotpo-drawer-layout";
    document.addEventListener("click", function (e) {
        const trigger = e.target.closest(triggerSelector);
        if (!trigger) return;
        const observer = new MutationObserver(function () {
            const drawer = document.querySelector(drawerSelector);
            if (drawer && trigger.getAttribute("aria-expanded") === "true") {
                const firstFocusable = drawer.querySelector('.yotpo-close-icon, button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (firstFocusable) {
                    firstFocusable.focus();
                    observer.disconnect();
            }}});
        observer.observe(document.body, {childList: true,subtree: true,attributes: true});});
    document.addEventListener("click", function (e) {
        const close = e.target.closest("#yotpo-drawer-layout .yotpo-close-icon");
        if (!close) return;
        let attempts = 0;
        const focusBack = setInterval(function () {
            attempts++;
            const trigger = document.querySelector(triggerSelector);
            if (!trigger) return;
            const isClosed =trigger.getAttribute("aria-expanded") === "false";
            if (isClosed) {trigger.focus();}
            if (attempts >= 20) {clearInterval(focusBack);}
    }, 100);});
    document.addEventListener("keydown", function (e) {
        if (e.key !== "Tab") return;
        const trigger = document.querySelector(triggerSelector);
        if (!trigger || trigger.getAttribute("aria-expanded") !== "true") return;
        const drawer = document.querySelector(drawerSelector);
        if (!drawer) return;
        const focusable = Array.from(
            drawer.querySelectorAll('.yotpo-close-icon, button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function (el) {
            return el.offsetParent !== null;});
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();}
        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();}
    });
//
let fixKlaviyoLoading = function () {
    let button = $('.klaviyo-form button');
    if (!button.length) return;
    if (!button.next('.sr-only.klaviyo-loading-status').length) {button.after('<div class="sr-only klaviyo-loading-status" role="status" aria-live="polite" aria-atomic="true"></div>');}
    let status = button.next('.klaviyo-loading-status');
    if (button.hasClass('klaviyo-spinner') || button.find('.klaviyo-spinner').length
    ) {
        if (status.text() !== 'Loading') {status.text('Loading');}
    } else {if (status.text() !== '') {status.text('');}}
};
fixKlaviyoLoading();
new MutationObserver(fixKlaviyoLoading).observe(document.body, {childList: true,subtree: true,attributes: true,attributeFilter: ['class']});
let bukiKlaviyoA11yObserver = new MutationObserver(function () {
    let bukiKlaviyoRichText = $('.kl-private-reset-css-Xuajs1 form.klaviyo-form .kl-private-reset-css-Xuajs1 .go1381663612 .klaviyo-form-richtext');
    if (bukiKlaviyoRichText.length && !bukiKlaviyoRichText.next('h2.sr-only').length) {
        bukiKlaviyoRichText.attr('aria-hidden', 'true');
        bukiKlaviyoRichText.after('<h2 class="sr-only">JOIN NOW &amp; GET 15% OFF</h2>');}});
bukiKlaviyoA11yObserver.observe(document.body, {childList: true,subtree: true});
// 
$("<div>", {id: "sr-announcer","aria-live": "polite","aria-atomic": "true",role: "alert",style:"position:absolute; left:-9999px; height:1px; width:1px; overflow:hidden;",}).appendTo("body");
  function announce(message) {const $announcer = $("#sr-announcer");
    $announcer.text("");
    setTimeout(() => {$announcer.text(message);}, 50);}
  function bindAnnounce(selector, message) {
    $(selector).on("click keydown", function (e) {
      if (e.type === "click" || (e.type === "keydown" && (e.key === "Enter" || e.key === " " || e.key === "Spacebar"))
      ) {
        announce(message);
        console.log("Button hit");
      }});
  }
  bindAnnounce("button.flickity-previous,button.flickity-next", "Slide changed");
  bindAnnounce("button.pswp__button--arrow--left,button.pswp__button--arrow--right", "Slide changed");
$(".product__thumbs .product__thumbs--scroller .product__thumb").on("click", function () {$(".product__thumbs--scroller .product__thumb").removeAttr("aria-current");
    $(this).attr("aria-current", "true");});
// 
let productTabsObserver = new MutationObserver(function () {

    $(".product__thumbs--scroller").each(function () {

        let $tablist = $(this);

        let $tabs = $tablist.find(".product__thumb");

        $tablist.attr("role", "tablist");

        $tabs.each(function (index) {

            let $tab = $(this);

            let imageAlt = $tab.find("img").attr("alt") || "";

            $tab.attr({
                "role": "tab",
                "aria-selected": $tab.hasClass("is-active") ? "true" : "false",
                "tabindex": $tab.hasClass("is-active") ? "0" : "-1",
                "aria-label": imageAlt + " - Thumbnail image " + (index + 1)
            });

        });

    });

    $(".modal--quick-shop.modal--is-active").attr({
        "role": "dialog",
        "aria-modal": "true",
        "aria-label": "Quick Shop dialog"
    });

});

productTabsObserver.observe(document.body, {
    childList: true,
    subtree: true
});
$(document).off("keydown.productTabs", ".product__thumb").on("keydown.productTabs", ".product__thumb", function (event) {
        if (
            event.key !== "ArrowRight" &&
            event.key !== "ArrowLeft"
        ) {return;}
        event.preventDefault();
        event.stopPropagation();
        let $tablist = $(this).closest(".product__thumbs--scroller");
        let $tabs = $tablist.find(".product__thumb");
        let current = $tabs.index(this);
        let next = current;
        if (event.key === "ArrowRight") {next = (current + 1) % $tabs.length;}
        if (event.key === "ArrowLeft") {next = (current - 1 + $tabs.length) % $tabs.length;}
        let $nextTab = $tabs.eq(next);
        $tabs.attr({"aria-selected": "false","tabindex": "-1"});
        $nextTab.attr({"aria-selected": "true","tabindex": "0"});
        $nextTab[0].click();
        $nextTab.focus();
    });
// 
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    let details = document.querySelector('details.site-nav__details[open]:hover');
    if (!details) {details = document.activeElement.closest('details.site-nav__details[open]');}
    if (!details) return;
    e.preventDefault();
    e.stopPropagation();
    let summary = details.querySelector('summary');
    details.removeAttribute('open');
    details.setAttribute('aria-expanded', 'false');
    if (summary) {summary.setAttribute('aria-expanded', 'false');
        setTimeout(function () {summary.focus();}, 0);}
}, true);
// 
// silde play pause
const slider = document.querySelector(".hero.flickity-enabled");
if (slider) {
    function updateSlides() {
        const slides = slider.querySelectorAll(".slideshow__slide");
        slides.forEach(function (slide) {
            const interactiveElements = slide.querySelectorAll('a, button, input, select, textarea');
            if (slide.classList.contains("is-selected")) {
                slide.setAttribute("aria-hidden","false");
                interactiveElements.forEach(function (element) {element.setAttribute("tabindex","0");});}
            else {
                slide.setAttribute("aria-hidden","true");
                interactiveElements.forEach(function (element) {element.setAttribute("tabindex","-1");});
            }
        });
    }
    updateSlides();
    const sliderObserver = new MutationObserver(function () {updateSlides();});
    sliderObserver.observe(slider, {subtree: true,attributes: true,attributeFilter: ["class"]});
    if (!slider.querySelector(".announcement-slider-play-pause")
    ) {
        const playPauseButton = document.createElement("button");
        playPauseButton.type = "button";
        playPauseButton.className ="announcement-slider-play-pause";
        playPauseButton.setAttribute("aria-label","Pause slideshow");
        playPauseButton.innerHTML = `
            <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="24" height="24">
                <rect x="6" y="5" width="4" height="14"></rect>
                <rect x="14" y="5" width="4" height="14"></rect>
            </svg>
        `;
        slider.appendChild(playPauseButton);
        let isPaused = false;
        function toggleSlider() {
            let flkty = null;
            if (
                window.jQuery &&
                window.jQuery(slider).data("flickity")
            ) {
                flkty =window.jQuery(slider).data("flickity");}
            if (
                !flkty &&
                typeof Flickity !== "undefined"
            ) {
                flkty = Flickity.data(slider);
            }
            if (!flkty) {
                return;}
            isPaused = !isPaused;
            if (isPaused) {
                if (
                    typeof flkty.pausePlayer ===
                    "function"
                ) {
                    flkty.pausePlayer();}
                playPauseButton.setAttribute("aria-label","Play slideshow");
                playPauseButton.innerHTML = `
                    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="24" height="24">
                        <path d="M8 5v14l11-7z"></path>
                    </svg>
                `;
            }
            else {
                if (
                    typeof flkty.playPlayer ===
                    "function"
                ) {
                    flkty.playPlayer();}
                playPauseButton.setAttribute("aria-label","Pause slideshow");
                playPauseButton.innerHTML = `
                    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="24" height="24">
                        <rect x="6" y="5" width="4" height="14"></rect>
                        <rect x="14" y="5" width="4" height="14"></rect>
                    </svg>
                `;
            }}
        playPauseButton.addEventListener("click",
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                toggleSlider();
            });}
}
// video play /apuse
const videoSection = document.querySelector('.video-parent-section.background-media-text');
if (videoSection) {
    const video = videoSection.querySelector('video.video-div');
    if (video && !document.querySelector('.video-play-pause')) {
        const playPauseButton = document.createElement('button');
        playPauseButton.type = 'button';
        playPauseButton.className = 'video-play-pause';
        playPauseButton.setAttribute('aria-label','Pause video');
        playPauseButton.innerHTML = `
            <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="24" height="24">
                <rect x="6" y="5" width="4" height="14"></rect>
                <rect x="14" y="5" width="4" height="14"></rect>
            </svg>
        `;
        const spacer = document.querySelector('.background-media-text__spacer.background-media-text--650');
        if (spacer) {spacer.insertAdjacentElement('afterend',playPauseButton);}
        playPauseButton.addEventListener('click', function () {
            if (video.paused) {
                video.play();
                playPauseButton.setAttribute('aria-label','Pause video');
                playPauseButton.innerHTML = `
                    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="24" height="24">
                        <rect x="6" y="5" width="4" height="14"></rect>
                        <rect x="14" y="5" width="4" height="14"></rect>
                    </svg>
                `;
            } else {
                video.pause();
                playPauseButton.setAttribute('aria-label','Play video');
                playPauseButton.innerHTML = `
                    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="24" height="24">
                        <path d="M8 5v14l11-7z"></path>
                    </svg>
                `;
    }});}
}
// 
let filterDrawer = document.querySelector("#FilterDrawer");
if (filterDrawer) {let isTrappingFocus = false;
    document.addEventListener("focusin", function (e) {
        if (!filterDrawer.classList.contains("drawer--is-open")) {return;}
        if (filterDrawer.contains(e.target)) {return;}
        if (isTrappingFocus) {return;}
        isTrappingFocus = true;
        let focusableElements =filterDrawer.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (focusableElements.length) {
            let firstFocusableElement =focusableElements[0];
            let lastFocusableElement =focusableElements[focusableElements.length - 1];
            if (window.filterDrawerShiftTab) {lastFocusableElement.focus();}
            else {firstFocusableElement.focus();}}
            isTrappingFocus = false;}, true);
    document.addEventListener("keydown", function (e) {
        if (!filterDrawer.classList.contains("drawer--is-open")) {return;}
        if (e.key === "Tab") {window.filterDrawerShiftTab = e.shiftKey;}}, true);
}
// 
let keyboardFocus = false;
let getSwatchActivator = function (item) {
    return $(item).find(".swatch-group-selector, [swatch-url], .swatch-button").get(0) || null;
};
let activateFocusedSwatch = function (item) {
    let activator = getSwatchActivator(item);
    if (!activator) return;
    let url = $(activator).data("swatch-url") || activator.getAttribute("swatch-url");
    if (url) activator.setAttribute("swatch-url", url);
    activator.click();
};
$(document).on("keydown", ".swatch-view-item[role='radio']", function (e) {
    if (e.key === "ArrowLeft" || e.key === "ArrowRight") {keyboardFocus = true;}
    if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        keyboardFocus = false;
        activateFocusedSwatch(this);
    }
});
$(document).on("focus", ".swatch-view-item[role='radio']", function () {
    let button = $(this).find(".swatch-button");
    if (keyboardFocus && button.attr("swatch-url")) {button.data("swatch-url", button.attr("swatch-url"));
        button.removeAttr("swatch-url");}});

$(document).on("keyup", ".swatch-view-item[role='radio']", function (e) {if (e.key === "ArrowLeft" || e.key === "ArrowRight") {keyboardFocus = false;}});
let fixSwatchRadio = function () {
    $(".grid-product__meta variant-swatch-king ul.swatch-view").each(function () {
        let $group = $(this);
        let $items = $group.children("li[role='radio']");
        if (!$items.length) return;
        if (!$group.attr("data-swatch-a11y-init")) {
            $items.attr({"tabindex": "-1","aria-checked": "false"});
            $items.first().attr({"tabindex": "0","aria-checked": "true"});
            $group.attr("data-swatch-a11y-init", "true");
        }
        $items.off("keydown.swatchA11y").on("keydown.swatchA11y", function (e) {
            if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
                e.preventDefault();
                e.stopImmediatePropagation();
                $items.attr({"tabindex": "-1","aria-checked": "false"});
                $(this).attr({"tabindex": "0","aria-checked": "true"});
                activateFocusedSwatch(this);
                return;
            }
            if (
                e.key !== "ArrowRight" &&
                e.key !== "ArrowLeft" &&
                e.key !== "ArrowDown" &&
                e.key !== "ArrowUp"
            ) {
                return;
            }
            e.preventDefault();
            let currentIndex = $items.index(this);
            let newIndex = currentIndex;
            if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                newIndex = (currentIndex + 1) % $items.length;
            }
            if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                newIndex = (currentIndex - 1 + $items.length) % $items.length;
            }
            let $newItem = $items.eq(newIndex);
            $items.attr({"tabindex": "-1","aria-checked": "false"});
            $newItem.attr({"tabindex": "0","aria-checked": "true"});
            $newItem[0].focus();
        });});
};
fixSwatchRadio();
new MutationObserver(function () {setTimeout(function () {fixSwatchRadio();}, 100);
}).observe(document.body, {childList: true,subtree: true});
document.addEventListener("keydown", function (e) {
    if (
        e.key === "Tab" &&
        e.target.closest('.swatch-view [role="radio"]')
    ) {
        e.stopImmediatePropagation();
    }}, true);
// 
const askQuestionDialogObserver = new MutationObserver(function () {
    const askQuestionDialog = document.querySelector(".jdgm-revs-tab__main");
    if (!askQuestionDialog) return;
    askQuestionDialog.setAttribute("role", "dialog");
    askQuestionDialog.setAttribute("aria-modal", "true");
    askQuestionDialog.setAttribute("aria-label", "Ask a question");
    const askQuestionClose = askQuestionDialog.querySelector("a.jdgm-close-ico[role='button']");
    if (askQuestionClose) {
        askQuestionClose.setAttribute("tabindex", "0");
        askQuestionClose.setAttribute("aria-label", "Close");}
});
askQuestionDialogObserver.observe(document.body, {childList: true,subtree: true});
document.addEventListener("click", function (event) {
    const askQuestionTrigger = event.target.closest(".jdgm-revs-tab-btn.btn");
    if (!askQuestionTrigger) return;
    setTimeout(function () {
        const askQuestionDialog = document.querySelector(".jdgm-revs-tab__main");
        if (!askQuestionDialog) return;
        const askQuestionFocusable = Array.from(
            askQuestionDialog.querySelectorAll('a.jdgm-close-ico[role="button"][tabindex="0"], button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ).filter(function (element) {return element.offsetParent !== null;});
        if (askQuestionFocusable.length) {askQuestionFocusable[0].focus();}
    }, 300);
});
document.addEventListener("click", function (event) {
    const askQuestionClose = event.target.closest(".jdgm-revs-tab__main a.jdgm-close-ico");
    if (!askQuestionClose) return;
    setTimeout(function () {
        const askQuestionTrigger = document.querySelector(".jdgm-revs-tab-btn.btn");
        if (askQuestionTrigger) {askQuestionTrigger.focus();}
    }, 300);
});
document.addEventListener("keydown", function (event) {
    const askQuestionClose = event.target.closest(".jdgm-revs-tab__main a.jdgm-close-ico");
    if (
        askQuestionClose &&
        (event.key === "Enter" || event.key === " ")
    ) {
        event.preventDefault();
        askQuestionClose.click();
        return;
    }
    if (event.key !== "Tab") return;
    const askQuestionDialog = document.querySelector(".jdgm-revs-tab__main");
    if (!askQuestionDialog || !askQuestionDialog.offsetParent) return;
    const askQuestionFocusable = Array.from(
        askQuestionDialog.querySelectorAll('a.jdgm-close-ico[role="button"][tabindex="0"], button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {return element.offsetParent !== null;});
    if (!askQuestionFocusable.length) return;
    const askQuestionFirst = askQuestionFocusable[0];
    const askQuestionLast = askQuestionFocusable[askQuestionFocusable.length - 1];
    if (
        event.shiftKey &&
        document.activeElement === askQuestionFirst
    ) {
        event.preventDefault();
        askQuestionLast.focus();
    }
    else if (
        !event.shiftKey &&
        document.activeElement === askQuestionLast
    ) {
        event.preventDefault();
        askQuestionFirst.focus();
    }
});
// 
const hubLauncherTabindexObserver = new MutationObserver(function () {
    $('.HubLauncher-floatingWidget-EhR3z button.HubLauncherButton-button-zMGOT').removeAttr('tabindex');
    
});
hubLauncherTabindexObserver.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex']});
let announcementSlide = $('#AnnouncementSlide-announcement_mF6ARQ');
announcementSlide.prepend(announcementSlide.find('.announcement-text'));
let announcementObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" &&
            mutation.attributeName === "aria-hidden") {
            let announcementSlide =$(mutation.target).closest(".announcement-slider__slide");
            if (!announcementSlide.length) {return;}
            let announcementLink =announcementSlide.find(".announcement-link");
            if (announcementSlide.attr("aria-hidden") === "true") {announcementLink.attr("tabindex", "-1");} else {announcementLink.removeAttr("tabindex");
}}});
});
$(".announcement-slider__slide").each(function () {announcementObserver.observe(this, {attributes: true,attributeFilter: ["aria-hidden"]});});
// 
// //
$('img[src*="Buki_-_Icon_Set.png"]').attr('alt', 'One-way moisture protection');
$('img[src*="Buki_-_Icon_Set_5.png"]').attr('alt', 'Thermoregulation');
$('img[src*="Buki_-_Icon_Set_2.png"]').attr('alt', 'Wrinkle resistance');
$('img[src*="Buki_-_Icon_Set_6_80093770-1d86-4406-9ad0-c4b65d55b3c0.png"]').attr('alt', 'Stretch');
$('img[src*="Buki_-_Icon_Set_4.png"]').attr('alt', 'Odor neutralizing');
$('img[src*="Seattle_Times_Press_2048x2048.jpg"]').attr('alt', 'The Seattle Times: “Great for travel, you can dress it up or down and toss it in the washer and dryer.”');
$('img[src*="Evening_Magazine_Press_2_2048x2048.jpg"]').attr('alt', 'Evening Magazine and KING 5: “Buki brand merges high-end apparel with technical functional.”');
$('img[src*="Grey_Magazine_Press_2048x2048.jpg"]').attr('alt', 'Gray Magazine: “Moisturized, hydrated, and protected skin all from just wearing a shirt...”');
$('img[src*="Vanguard_Seattle_Press_2048x2048.jpg"]').attr('alt', 'Vanguard Seattle Art Fashion and Culture: “...you’ll be looking cool while staying warm in beautiful, architectural pieces that keep their shape all day long.”');
$('img[src*="Press_What_Jenn_Wore_3c7ca595-043b-4976-83a8-32819404424e_2048x2048.jpg"]').attr('alt', 'What Jenn Wore: “...this is a line that you will want to wear everyday, for every occasion.”');
$('img[src*="Seattle_Magazine_Press_2_2048x2048.jpg"]').attr('alt', 'Seattle magazine: “There’s no shortage of tech innovation in Seattle, but one new ‘start-up’ is cloaked as something different: a fashion collection.”');
$('img[src*="Well_Good_Press_2048x2048.jpg"]').attr('alt', 'Well+Good: “…upon first touch the case is uber-soft…”');
$('img[src*="Catherine_Grace_Press_2048x2048.jpg"]').attr('alt', 'CatherineGraceO: “Once you slip into a piece of Buki, you won’t want to slip out of it.”');
$('img[src*="WWD_Press_2048x2048.jpg"]').attr('alt', 'WWD: “Fabric that moisturizes the skin isn’t so Space-Age after all”');
$('img[src*="PopSugar_Press_2_995e3e66-99c7-495c-a166-68069e48023c_2048x2048.jpg"]').attr('alt', 'POPSUGAR: “…as soon as I felt the Buki Scoop Neck, I wanted to put it on, live in it forever…”');
$('img[src*="LA_Times_Press_724d36c5-058f-47a0-814d-01011668a335_2048x2048.jpg"]').attr('alt', 'Los Angeles Times: “…dress your way to softer skin.”');
$('img[src*="Seattle_Magazine_Press_2048x2048.jpg"]').attr('alt', 'Seattle magazine: “…designs that are truly technology-based and luxurious in feel.”');
$('img[src*="Brit_Co_Press_2048x2048.jpg"]').attr('alt', 'BRIT+CO: “Collagen-infused RTW could be the best travel hack for preventing dry skin.”');
$('img[src*="The_Hollywood_Reporter_Press_2048x2048.jpg"]').attr('alt', 'The Hollywood Reporter: “While most tech fabrics on the market are synthetic, Buki fabrics stand out as eco-friendly.”');

const storeLocatorObserver = new MutationObserver(function () {
    const $addressList = $("#addresses_list");
    if ($addressList.length && !$("#store-results-announcement").length) {
        $('<div id="store-results-announcement" role="status" aria-live="polite" aria-atomic="true"></div>').css({position: "absolute",width: "1px",height: "1px",overflow: "hidden",clip: "rect(0, 0, 0, 0)"}).appendTo($addressList);
        storeLocatorObserver.disconnect();}
});
storeLocatorObserver.observe(document.body, {childList: true,subtree: true});
$(document).on("click", "#submitBtn", function () {
    setTimeout(function () {
        const resultCount = $("#addresses_list li").length;
        if (resultCount > 0) {
            $("#store-results-announcement").text("");
            setTimeout(function () {
                $("#store-results-announcement").text(
                    resultCount +
                    " store location" +
                    (resultCount > 1 ? "s" : "") +
                    " found."
            );}, 100);}}, 2000);
});
if ($(".scrolling-text__inner").length) {
    $(".scrolling-text").each(function () {
        const $scrollingText = $(this);
        const $scrollingInner = $scrollingText.find(".scrolling-text__inner");
        if ($scrollingText.next(".scrolling-text-control").length) return;
        const $control = $(
            '<button type="button" class="scrolling-text-control" aria-label="Pause scrolling text">' +
                '<span aria-hidden="true">❚❚</span>' +
            '</button>');
        $scrollingText.after($control);
        $control.on("click", function () {
            const isPaused =$scrollingInner.css("animation-play-state") === "paused";
            $scrollingInner.css("animation-play-state",isPaused ? "running" : "paused");
            $(this).attr("aria-label",isPaused ? "Pause scrolling text": "Play scrolling text").find("span").text(isPaused ? "❚❚" : "▶");
        });});
}
// second half 1
// 
 $(".cart .cart__item .cart__item-sub .js-qty__wrapper").each(function () {
        let $wrapper = $(this);
        let $input = $wrapper.find(".js-qty__num");
        let $minus = $wrapper.find(".js-qty__adjust--minus");
        let $plus = $wrapper.find(".js-qty__adjust--plus");
        if (!$wrapper.find(".qty-announcement").length) {$wrapper.after('<div class="qty-announcement visually-hidden" role="status" aria-live="polite" aria-atomic="true"></div>');}
        function updateQuantity() {
            let quantity = parseInt($input.val()) || 0;
            if (quantity <= 1) {
                $minus.attr("disabled", "disabled").attr("tabindex", "-1");
            } else {$minus.removeAttr("disabled").removeAttr("tabindex");}}
        updateQuantity();
        $input.on("change input", function () {updateQuantity();});
        $plus.on("click", function () {
            setTimeout(function () {updateQuantity();
                let quantity = parseInt($input.val()) || 0;
                $wrapper.next(".qty-announcement").text("Item quantity increased to " + quantity);}, 100);});
        $minus.on("click", function () {
            setTimeout(function () {updateQuantity();
                let quantity = parseInt($input.val()) || 0;
                $wrapper.next(".qty-announcement").text("Item quantity decreased to " + quantity);}, 100);});
    });
//  
let contactUsSuccessMessage = document.querySelector('form.contact-form .note.note--success');
if (contactUsSuccessMessage) {
    const contactUsSuccessText = contactUsSuccessMessage.textContent.trim();
    contactUsSuccessMessage.setAttribute("role", "alert");
    contactUsSuccessMessage.setAttribute("aria-atomic", "true");
    contactUsSuccessMessage.textContent = "";
    setTimeout(function () {
        contactUsSuccessMessage.textContent = contactUsSuccessText;
        
    }, 300);
}
// 
let triggerElement = null;
$(document).on("click",".ks-chart-modal-link.sizing-chart-modal-link.with-icon",
    function () {
        triggerElement = this;
        let focusAttempts = 0;
        let modalFocusInterval = setInterval(function () {
            focusAttempts++;
            let $modal = $(".kiwi-sizing-modal:visible");
            if ($modal.length) {
                let $focusable = $modal.find('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(":visible");
                if ($focusable.length) {
                    $focusable.first().focus();
                    clearInterval(modalFocusInterval);}}
            if (focusAttempts >= 30) {clearInterval(modalFocusInterval);}
        }, 100);});
$(document).on("keydown",".ks-chart-modal-link.sizing-chart-modal-link.with-icon",
    function (e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            triggerElement = this;
            $(this).trigger("click");
        }});
$(document).on("keydown",".kiwi-sizing-modal .ks-modal-close",
    function (e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            $(this).trigger("click");
        }});
$(document).on("click",".kiwi-sizing-modal .ks-modal-close",
    function () {
        let closeAttempts = 0;
        let closeInterval = setInterval(function () {
            closeAttempts++;
            let $modal = $(".kiwi-sizing-modal:visible");
            if (!$modal.length) {
                if (
                    triggerElement &&
                    document.body.contains(triggerElement)
                ) {
                    triggerElement.focus();}
                clearInterval(closeInterval);}
            if (closeAttempts >= 30) {clearInterval(closeInterval);}}, 100);
    }
);
$(document).on("keydown", function (e) {
    if (e.key !== "Tab") return;
    let $modal = $(".kiwi-sizing-modal:visible");
    if (!$modal.length) return;
    let $focusable = $modal.find('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(":visible");
    if (!$focusable.length) return;
    let firstElement = $focusable.first()[0];
    let lastElement = $focusable.last()[0];
    if (
        e.shiftKey &&
        document.activeElement === firstElement
    ) {
        e.preventDefault();
        lastElement.focus();
    }
    else if (
        !e.shiftKey &&
        document.activeElement === lastElement
    ) {
        e.preventDefault();
        firstElement.focus();
    }
});
// 

$(".product-block.product-block--tab .collapsibles-wrapper .collapsible-content__inner .table-wrapper table").each(function () {
    const $table = $(this);
    if ($table.find("caption").length) return;
    const $content = $table.closest(".collapsible-content__inner");
    let headingText = "";
    $content.find("h5").each(function () {
        if ($(this)[0].compareDocumentPosition($table[0]) & Node.DOCUMENT_POSITION_FOLLOWING) {headingText = $(this).text().trim();}});
    let captionText = "";
    if (headingText === "Contiguous U.S.") {
        captionText = "Shipping costs and delivery methods for the contiguous United States";
    } else if (headingText === "Alaska & Hawaii") {
        captionText = "Shipping costs and delivery methods for Alaska and Hawaii";
    } else if (headingText === "International") {captionText = "International shipping costs and estimated delivery times";}
    if (captionText) {
        $table.prepend('<caption class="sr-only">' +captionText +'</caption>');}
});
// 

  
//   
$(document).on("keydown", ".pswp.pswp--open", function (e) {
    if (e.key !== "Tab") return;
    const photoSwipeModal = this;
    const photoSwipeFocusable = $(photoSwipeModal).find("button:not([disabled]), " + "a[href], " + "input:not([disabled]), " + "select:not([disabled]), " + "textarea:not([disabled]), " + "[tabindex]:not([tabindex='-1'])").filter(":visible");
    if (!photoSwipeFocusable.length) return;
    const photoSwipeFirst = photoSwipeFocusable.first()[0];
    const photoSwipeLast = photoSwipeFocusable.last()[0];
    if (
        e.shiftKey && document.activeElement === photoSwipeFirst
    ) {
        e.preventDefault();
        photoSwipeLast.focus();
    } else if (
        !e.shiftKey && document.activeElement === photoSwipeLast
    ) {e.preventDefault();
        photoSwipeFirst.focus();}});
let photoSwipeLastTrigger = null;
$(document).on("click","button.js-photoswipe__zoom.product__photo-zoom",function () {photoSwipeLastTrigger = this;});
$(document).on("keydown","button.js-photoswipe__zoom.product__photo-zoom",
    function (e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            $(this).trigger("click");}}
);
let photoSwipeWasOpen = false;
const photoSwipeFocusObserver = new MutationObserver(function () {
    const photoSwipeOpenModal = document.querySelector(".pswp.pswp--open[aria-hidden='false']");
    if (photoSwipeOpenModal) {photoSwipeWasOpen = true;
        return;}
    if (photoSwipeWasOpen && photoSwipeLastTrigger && document.body.contains(photoSwipeLastTrigger)
    ) {
        photoSwipeWasOpen = false;
        setTimeout(function () {photoSwipeLastTrigger.focus();}, 150);}
});
photoSwipeFocusObserver.observe(document.body, {childList: true,subtree: true,attributes: true,attributeFilter: ["class","aria-hidden"]});
// 
$(document).on('focusin', '.swatch-view-item', function () {
    const $currentSwatch = $(this);
    const tooltipText = $currentSwatch.attr('title');
    $('.custom-swatch-tooltip').remove();
    if (!tooltipText) {return;}
    const $swatchTooltip = $('<div>', {class: 'custom-swatch-tooltip',text: tooltipText});
    $('body').append($swatchTooltip);
    const swatchOffset = $currentSwatch.offset();
    $swatchTooltip.css({
        position: 'absolute',
        top: swatchOffset.top - $swatchTooltip.outerHeight() - 10,
        left: swatchOffset.left + ($currentSwatch.outerWidth() / 2),
        transform: 'translateX(-50%)',
        zIndex: '999999',
        background: '#000',
        color: '#fff',
        padding: '5px 10px',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        borderRadius: '3px'
    });
});
$(document).on('focusout', '.swatch-view-item', function () {$('.custom-swatch-tooltip').remove();});
document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') {
        document.querySelectorAll('.custom-swatch-tooltip').forEach(function (tooltip) {tooltip.remove();});
}}, true);
// 
$(document).on('click', '.jdgm-revs-tab__content form.jdgm-form .jdgm-submit-rev', function () {
    const jdgmReviewForm = $(this).closest('form.jdgm-form');
    let jdgmFocusAttempts = 0;
    const jdgmFocusTimer = setInterval(function () {
        let jdgmTargetField = $();
        const jdgmRatingError = jdgmReviewForm.find('input[name="score"][aria-invalid="true"]');
        if (jdgmRatingError.length) {jdgmTargetField = jdgmReviewForm.find('.jdgm-form__rating [role="radio"]').first();}
        if (!jdgmTargetField.length) {jdgmTargetField = jdgmReviewForm.find('textarea[aria-invalid="true"], input:not([type="hidden"])[aria-invalid="true"], select[aria-invalid="true"]').filter(':visible').first();}
        if (jdgmTargetField.length) {
            jdgmTargetField[0].focus();
            if (document.activeElement === jdgmTargetField[0]) {clearInterval(jdgmFocusTimer);}}
        jdgmFocusAttempts++;
        if (jdgmFocusAttempts >= 50) {clearInterval(jdgmFocusTimer);}
}, 100);
});
// 
$(document).on('click','.modal--quick-shop .modal__centered button.modal__close',
    function () {
        $('.grid.grid--uniform .grid-product__content .grid-product__image-mask button.quick-product__btn').attr('aria-expanded', 'false');
    });
// slide buttons for products
function addCollectionSliderButtons() {
        $('.grid-overflow-wrapper').each(function () {
            const wrapper = $(this);
            if (wrapper.find('.custom-collection-prev').length) {return;}
            const grid = wrapper.find('.grid--uniform').first();
            if (!grid.length) {return;}
            const items = grid.children('.grid__item');
            if (items.length < 2) {return;}
            wrapper.prepend(`
                <button type="button" class="custom-collection-prev" aria-label="Previous products">
                    <svg aria-hidden="true" viewBox="0 0 24 24">
                        <path d="M15 18L9 12L15 6"></path>
                    </svg></button>`);
            wrapper.append(`
                <button type="button" class="custom-collection-next" aria-label="Next products">
                    <svg aria-hidden="true" viewBox="0 0 24 24">
                        <path d="M9 18L15 12L9 6"></path>
                    </svg></button>`);
            updateCollectionSliderButtons(wrapper);
        });}
    function updateCollectionSliderButtons(wrapper) {
        const grid = wrapper.find('.grid--uniform').first();
        if (!grid.length) {return;}
        const maxScroll =grid[0].scrollWidth - grid[0].clientWidth;
        const currentScroll = grid[0].scrollLeft;
        wrapper.find('.custom-collection-prev').prop('disabled', currentScroll <= 1).attr('aria-disabled',currentScroll <= 1 ? 'true' : 'false');
        wrapper.find('.custom-collection-next').prop('disabled', currentScroll >= maxScroll - 1).attr('aria-disabled',currentScroll >= maxScroll - 1 ? 'true' : 'false');
    }
    $(document).on('click','.custom-collection-prev, .custom-collection-next',
        function (e) {
            e.preventDefault();
            e.stopPropagation();
            const button = $(this);
            const wrapper = button.closest('.grid-overflow-wrapper');
            const grid = wrapper.find('.grid--uniform').first();
            if (!grid.length) {return;}
            const firstItem = grid.children('.grid__item').first();
            if (!firstItem.length) {return;}
            const scrollAmount = firstItem.outerWidth(true);
            grid[0].scrollBy({left: button.hasClass('custom-collection-next') ? scrollAmount : -scrollAmount, behavior: 'smooth'});
            setTimeout(function () {updateCollectionSliderButtons(wrapper);}, 400);}
    );
    $('.grid-overflow-wrapper .grid--uniform').on('scroll',
        function () {
            updateCollectionSliderButtons($(this).closest('.grid-overflow-wrapper'));}
    );
    const collectionSliderObserver = new MutationObserver(
        function () {addCollectionSliderButtons();}
    );
    collectionSliderObserver.observe(document.body, {childList: true,subtree: true});
    addCollectionSliderButtons();
// 

//gif play pause 
(function () {
    function bukiGifPauseControl() {
        const $bukiGifThumb = $('.product__thumb-item[data-index="9"]');
        const $bukiGifMain = $('.product-main-slide[data-index="9"]');
        const $bukiGifThumbImg = $bukiGifThumb.find('img.image-element');
        const $bukiGifMainImg = $bukiGifMain.find('img.photoswipe__image');
        if (!$bukiGifThumbImg.length || !$bukiGifMainImg.length) {return;}
        if (!$bukiGifThumb.find('.buki-gif-play-pause').length) {
            $bukiGifThumb.css('position', 'relative');
            $bukiGifThumb.append(`
                <button type="button" class="buki-gif-play-pause" aria-label="Pause image animation">
                    <span class="buki-gif-pause-icon" aria-hidden="true">Ⅱ</span>
                    <span class="buki-gif-play-icon" aria-hidden="true">▶</span>
                </button>
            `);
            const $bukiGifButton = $bukiGifThumb.find('.buki-gif-play-pause');
            const $bukiGifPauseIcon = $bukiGifThumb.find('.buki-gif-pause-icon');
            const $bukiGifPlayIcon = $bukiGifThumb.find('.buki-gif-play-icon');
            $bukiGifPlayIcon.hide();
            let bukiGifPaused = false;
            let $bukiThumbCanvas = null;
            let $bukiMainCanvas = null;
            function bukiCaptureGif($img, canvasClass) {
                const img = $img[0];
                const canvas = document.createElement('canvas');
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                const context = canvas.getContext('2d');
                context.drawImage(
                    img,
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );
                $(canvas)
                    .addClass(canvasClass)
                    .css({
                        width: '100%',
                        height: 'auto'
                    });
                return $(canvas);
            }
            $bukiGifButton.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (!bukiGifPaused) {
                    try {
                        $bukiThumbCanvas = bukiCaptureGif($bukiGifThumbImg,'buki-gif-thumb-paused-frame');
                        $bukiMainCanvas = bukiCaptureGif($bukiGifMainImg,'buki-gif-main-paused-frame');
                        $bukiGifThumbImg.hide();
                        $bukiGifMainImg.hide();
                        $bukiGifThumbImg.after($bukiThumbCanvas);
                        $bukiGifMainImg.after($bukiMainCanvas);
                        bukiGifPaused = true;
                        $bukiGifButton.attr('aria-label', 'Play image animation');
                        $bukiGifPauseIcon.hide();
                        $bukiGifPlayIcon.show();
                    } catch (error) {
                        console.log('Unable to pause GIF:', error);
                    }
                }
                else {
                    if ($bukiThumbCanvas) {
                        $bukiThumbCanvas.remove();
                        $bukiThumbCanvas = null;
                    }
                    if ($bukiMainCanvas) {
                        $bukiMainCanvas.remove();
                        $bukiMainCanvas = null;
                    }
                    const thumbSrc = $bukiGifThumbImg.attr('src');
                    $bukiGifThumbImg.attr('src',thumbSrc.split('&bukiGifRestart=')[0] + '&bukiGifRestart=' + Date.now());
                    const mainSrc = $bukiGifMainImg.attr('src');
                    $bukiGifMainImg.attr('src',mainSrc.split('&bukiGifRestart=')[0] + '&bukiGifRestart=' + Date.now());
                    $bukiGifThumbImg.show();
                    $bukiGifMainImg.show();
                    bukiGifPaused = false;
                    $bukiGifButton.attr('aria-label', 'Pause image animation');
                    $bukiGifPauseIcon.show();
                    $bukiGifPlayIcon.hide();
                }});
        }}
    $(window).on('load', function () {
        bukiGifPauseControl();
    });
    const bukiMainGifMutationObserver =
        new MutationObserver(function () {
            bukiGifPauseControl();
        });
    bukiMainGifMutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
})();
// 
// second half 2
// // Create live region for filter announcements
    if (!$('#filter-accessibility-announcement').length) {
        $('body').append(
            '<div id="filter-accessibility-announcement" ' +
            'role="status" ' +
            'aria-live="polite" ' +
            'aria-atomic="true" ' +
            'class="sr-only"></div>'
        );
    }
    $(document).on(
        'change',
        '#CollectionSidebar .filter-form input.tag__input[type="checkbox"]',
        function () {
            const $checkbox = $(this);
            const filterLabel = $checkbox
                .closest('label')
                .find('.tag__text')
                .first()
                .text()
                .trim();
            if (!filterLabel) {
                return;
            }
            const $announcement =
                $('#filter-accessibility-announcement');
            if ($checkbox.prop('checked')) {
                $checkbox.attr(
                    'aria-label',
                    filterLabel + ', filter'
                );
                $announcement.text(
                    'Filter applied: ' + filterLabel
                );
            } else {
                $checkbox.attr(
                    'aria-label',
                    filterLabel + ', filter'
                );
                $announcement.text(
                    'Filter removed: ' + filterLabel
                );
            }
        }
    );
// 
$('.jdgm-carousel.jdgm-carousel--card-theme').each(function () {
    const $carousel = $(this);
    const $arrows = $carousel.find('.jdgm-carousel__arrows');
    if (!$arrows.length || $arrows.find('.jdgm-carousel__pause').length) {
        return;
    }
    const $next = $arrows.find('.jdgm-carousel__right-arrow');
    if (!$next.length) {
        return;
    }
    $arrows.append(`
        <button type="button" class="jdgm-carousel__pause" aria-label="Pause reviews carousel">
            <span class="jdgm-carousel__pause-icon" aria-hidden="true">Ⅱ</span>
            <span class="jdgm-carousel__play-icon" aria-hidden="true">▶</span>
        </button>
    `);
    const $button = $arrows.find('.jdgm-carousel__pause');
    const $pauseIcon = $button.find('.jdgm-carousel__pause-icon');
    const $playIcon = $button.find('.jdgm-carousel__play-icon');
    $playIcon.hide();
    let isPaused = false;
    let autoplayTimer = null;
    function startAutoplay() {
        clearInterval(autoplayTimer);
        autoplayTimer = setInterval(function () {
            if (isPaused) {
                return;
            }
            if (!$carousel.is(':visible')) {
                return;
            }
            $next.triggerHandler('click');
        }, 5000);
    }
    function stopAutoplay() {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
    }
    startAutoplay();
    $button.on('click.jdgmPause', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isPaused) {
            isPaused = true;
            stopAutoplay();
            $button.attr('aria-label','Play reviews carousel');
            $pauseIcon.hide();
            $playIcon.show();
        } else {
            isPaused = false;
            startAutoplay();
            $button.attr('aria-label','Pause reviews carousel');
            $pauseIcon.show();
            $playIcon.hide();
        }
    });
});
// 
    function ycwRemoveJudgeMeCarouselStatus() {
        $('.jdgm-carousel__status').remove();
    }

    ycwRemoveJudgeMeCarouselStatus();

    const ycwJudgeMeStatusObserver = new MutationObserver(function () {
        ycwRemoveJudgeMeCarouselStatus();
    });

    ycwJudgeMeStatusObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
// menu trap
// 
(function () {
    const drawerSelector = '#NavDrawer';
    let lastTrigger = null;
    let redirecting = false;
    function getDrawer() {
        return document.querySelector(drawerSelector);
    }
    function isOpen(drawer) {
        return drawer &&
            drawer.classList.contains('drawer--is-open');
    }
    function getFocusable(drawer) {
        return Array.from(drawer.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), ' +
            'select:not([disabled]), textarea:not([disabled]), ' +
            '[tabindex]:not([tabindex="-1"])'
        )).filter(function (el) {
            return el.offsetParent !== null;
        });
    }
    function moveInside() {
        const drawer = getDrawer();
        if (!drawer || !isOpen(drawer) || redirecting) return;
        const focusable = getFocusable(drawer);
        if (!focusable.length) return;
        if (!drawer.contains(document.activeElement)) {
            redirecting = true;
            focusable[0].focus({
                preventScroll: true
            });
            setTimeout(function () {
                redirecting = false;
            }, 10);
        }
    }
    function setBackground(open) {
        const selectors = [
            '#MainContent',
            '.shopify-section-group-footer-group',
            '.announcement-bar',
            '#CartDrawer',
            '#VideoModal'
        ];
        selectors.forEach(function (selector) {
            document.querySelectorAll(selector).forEach(function (element) {
                if (open) {
                    element.setAttribute('inert', '');
                    element.setAttribute('aria-hidden', 'true');
                } else {
                    element.removeAttribute('inert');
                    element.removeAttribute('aria-hidden');
                }
            });
        });
    }
    function update() {
        const drawer = getDrawer();
        if (!drawer) return;
        if (isOpen(drawer)) {
            setBackground(true);
            drawer.removeAttribute('inert');
            drawer.removeAttribute('aria-hidden');
            requestAnimationFrame(moveInside);
        } else {
            setBackground(false);
            if (lastTrigger) {
                setTimeout(function () {
                    if (document.contains(lastTrigger)) {
                        lastTrigger.focus();
                    }
                }, 30);
            }
        }
    }
    document.addEventListener('focusin', function (event) {
        const drawer = getDrawer();
        if (!drawer || !isOpen(drawer) || redirecting) return;
        if (!drawer.contains(event.target)) {
            moveInside();
        }
    }, true);
    document.addEventListener('keydown', function (event) {
        const drawer = getDrawer();
        if (!drawer || !isOpen(drawer)) return;
        if (event.key !== 'Tab') return;
        const focusable = getFocusable(drawer);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus({
                preventScroll: true
            });
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus({
                preventScroll: true
            });
        }
    }, true);
    document.addEventListener('click', function (event) {
        const trigger = event.target.closest(
            '#SiteHeader button.js-drawer-open-nav'
        );
        if (trigger) {
            lastTrigger = trigger;
        }
    }, true);
    function init() {
        update();
        const drawer = getDrawer();
        if (drawer) {
            new MutationObserver(function () {
                update();
            }).observe(drawer, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
        new MutationObserver(function () {
            update();
        }).observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
const navDrawerTrigger = document.querySelector(
    '#SiteHeader button.js-drawer-open-nav'
);
const navDrawer = document.querySelector('#NavDrawer');
const navDrawerClose = navDrawer.querySelector(
    '.drawer__close-button.js-drawer-close'
);
const navDrawerOutsideElements = document.querySelectorAll(
    'header, main, footer, .announcement-bar, #CartDrawer, .header-sticky-wrapper, .toolbar.small--hide'
);
navDrawerTrigger.addEventListener('click', function () {
    navDrawerOutsideElements.forEach(function (element) {
        if (!element.contains(navDrawer)) {
            element.setAttribute('aria-hidden', 'true');
            element.setAttribute('inert', '');
        }
    });
    setTimeout(function () {
        const firstInteractiveElement = navDrawer.querySelector(
            'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (firstInteractiveElement) {
            firstInteractiveElement.focus();
        }
    }, 300);
});
navDrawerClose.addEventListener('click', function () {
    navDrawerOutsideElements.forEach(function (element) {
        element.removeAttribute('aria-hidden');
        element.removeAttribute('inert');
    });
    setTimeout(function () {
        navDrawerTrigger.focus();
    }, 300);
});
document.addEventListener('keydown', function (event) {
    if (!navDrawer.classList.contains('is-open')) {
        return;
    }
    if (event.key !== 'Tab') {
        return;
    }
    const focusable = Array.from(
        navDrawer.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
    ).filter(function (element) {
        return !element.closest('[inert]') &&
            element.offsetParent !== null;
    });
    const firstElement = focusable[0];
    const lastElement = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
    }
});
document.addEventListener('keydown', function (event) {
    if (!navDrawer.classList.contains('is-open')) {
        return;
    }
    if (event.key !== 'Tab') {
        return;
    }
    const focusableElements = navDrawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const focusable = Array.from(focusableElements).filter(function (element) {
        return element.offsetParent !== null;
    });
    const firstElement = focusable[0];
    const lastElement = focusable[focusable.length - 1];
    if (event.shiftKey) {
        if (document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        }
    } else {
        if (document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    }
});


// 
// //
$(document).on("change", "#FilterDrawer input.tag__input[type='checkbox']", function () {
    let filterCount = $("#FilterDrawer input.tag__input[type='checkbox']:checked").length;
    if (!$("#filter-announcement").length) {
        $("<div>", {
            id: "filter-announcement",
            "aria-live": "polite",
            "aria-atomic": "true"
        }).css({
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: "0",
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            border: "0"
        }).appendTo("body");
    }
    setTimeout(function () {
        $("#filter-announcement").text(
            filterCount === 0
                ? "No filters applied."
                : filterCount === 1
                    ? "1 filter applied."
                    : filterCount + " filters applied."
        );
    }, 100);

});
// 
// 
const jdgmFocusObserver = new MutationObserver(function () {

    const jdgmForm = document.querySelector(
        ".jdgm-revs-tab__main form.jdgm-form"
    );

    const jdgmStar = document.querySelector(
        ".jdgm-revs-tab__main form.jdgm-form .jdgm-form__rating .jdgm-star"
    );

    if (!jdgmForm || !jdgmStar) return;

    if (
        document.activeElement &&
        document.activeElement.matches(
            ".jdgm-revs-tab__main .jdgm-revs-tab__actions a.jdgm-write-rev-link"
        )
    ) {
        setTimeout(function () {
            jdgmStar.focus();
        }, 100);
    }

});

jdgmFocusObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style", "aria-hidden"]
});
// 


    console.log("a11y end");

});